import { connect } from "react-redux";
import { SiteDown as Component, SiteDownProps } from "./SiteDown.component";
import { RootState } from "../../reducers";
import { getChatBotFeatureFlag } from "../../features";
import { getPartnerDetails } from "../../selector";
import { logChatIntakeResults, openChatbot } from "../../action";

const mapStateToProps = (state: RootState) =>
  ({
    chatEnabled: getChatBotFeatureFlag(state),
    partnerDetails: getPartnerDetails(state),
  } as Pick<SiteDownProps, "chatEnabled" | "partnerDetails">);

export const SiteDown = connect(mapStateToProps, {
  logChatIntakeResults,
  openChatbot,
} as Pick<SiteDownProps, "logChatIntakeResults" | "openChatbot">)(Component);
